import React from "react";
import DisplayData from "./display-data";
import NumberDatatype from "./number-datatype";

export default function ArrayDatatype({ value }) {
  return (
    <>
      (<NumberDatatype value={value.length} />) [
      {value.map((val, idx) => (
        <span
          key={String(idx)}
          style={{ color: "#ACC79E", fontFamily: "Roboto Mono" }}
        >
          <DisplayData value={val} inner={true} />
          {`${idx !== value.length - 1 ? ", " : ""}`}
        </span>
      ))}
      ]
    </>
  );
}
